import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreIssueTypesWorkflowRoute: InvariantJiraRoute = {
	name: 'project-settings-core-issuetypes-workflow',
	path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
	exact: true,
};
